import React from 'react';
import { legalFooter } from './legalFooter';

const AGENT_DOWNLOAD_URL = `${import.meta.env.VITE_API_URL || ''}/api/realplc-agent/download`;

/** Layout approved in the C 3.6.2 homepage preview. Interactions live in landingRuntime. */
export default function LandingMarkup() {
  return <>
    <header className="nav">
      <div className="container nav-in">
        <a aria-label="RealPLC 首页" className="logo" data-route="home" href="#home">
          <span aria-hidden="true" className="official-logo">
          </span>
          <span>
            {"RealPLC"}
            <small>
              {"AI FOR PLC ENGINEERING"}
            </small>
          </span>
        </a>
        <nav aria-label="主导航" className="navlinks" id="navLinks">
          <a data-nav="scenarios" href="#scenarios">
            {"应用场景"}
          </a>
          <a data-nav="ecosystem" href="#ecosystem">
            {"兼容平台"}
          </a>
          <a data-nav="modelChoice" href="#modelChoice">
            {"模型与安全"}
          </a>
          <a data-nav="workflow" href="#workflow">
            {"工作流程"}
          </a>
          <a data-nav="agent" href="#agent">
            {"RealPLC Agent"}
          </a>
          <a href="#contact" data-route="contact">
            {"联系我们"}
          </a>
        </nav>
        <div className="navright">
          <button className="btn nav-demo sm" data-route="demo" type="button">
            {"体验演示 ↗"}
          </button>
          <button className="btn primary nav-login" data-route="login" type="button">
            {"登录 / 注册 "}
            <span aria-hidden="true">
              {"↗"}
            </span>
          </button>
          <button aria-controls="navLinks" aria-expanded="false" aria-label="打开菜单" className="mobile-toggle" id="mobileMenu" type="button">
            <svg aria-hidden="true" viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
              <path d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>
      </div>
    </header>
    <main>
      <div className="view active" id="view-home">
        <section className="hero">
          <div className="container">
            <div className="hero-layout">
              <div className="hero-copy">
                <div className="eyebrow">
                  <span className="pulse">
                  </span>
                  {" REALPLC · INDUSTRIAL AI WORKSPACE"}
                </div>
                <h1>
                  {"从控制需求，"}
                  <br />
                  <span className="shine">
                    {"到原生编译验证。"}
                  </span>
                </h1>
                <p className="hero-desc">
                  {"确认需求、审批计划、生成 ST/SCL 代码，通过本地 Agent 连接 TIA Portal 或 CODESYS，获取原生编译诊断。让每一次修改都有依据。"}
                </p>
                <div className="promptbox">
                  <textarea aria-label="输入 PLC 控制需求" id="heroPrompt" spellCheck="false" defaultValue={"帮我设计一条输送线的启停控制：需要过载保护、急停联锁、运行反馈超时报警，故障消除后必须人工复位，禁止自动重启。"} />
                  <div className="prompt-bottom">
                    <select aria-label="选择开发环境" className="modelselect" id="platform">
                      <option value="CODESYS ST">
                        {"CODESYS · ST"}
                      </option>
                      <option value="TIA Portal SCL">
                        {"Siemens TIA · SCL"}
                      </option>
                    </select>
                    <button className="btn primary" id="heroLaunch" type="button">
                      {"开始工程演示 →"}
                    </button>
                  </div>
                </div>
                <div className="hero-under">
                  <span className="demo-dot" aria-hidden="true">
                  </span>
                  {" 先体验工程流程；实际编译需连接本地 Agent。"}
                </div>
                <div className="quick-scenarios">
                  <span className="quick-label">
                    {"快速试一试"}
                  </span>
                  <div className="prompt-chips" id="heroChips">
                    <button className="active" data-scene="conveyor" type="button">
                      {"↗ 输送线启停"}
                    </button>
                    <button data-scene="motor" type="button">
                      {"↗ 电机与故障复位"}
                    </button>
                    <button data-scene="mixer" type="button">
                      {"↗ 批次混料"}
                    </button>
                    <button data-scene="alarm" type="button">
                      {"↗ 报警矩阵"}
                    </button>
                  </div>
                </div>
                <div className="micro-trust">
                  <span>
                    <i aria-hidden="true">
                      {"↳"}
                    </i>
                    {" 审批可追溯"}
                  </span>
                  <span>
                    <i aria-hidden="true">
                      {"↳"}
                    </i>
                    {" 多模型 / 自定义端点"}
                  </span>
                  <span>
                    <i aria-hidden="true">
                      {"↳"}
                    </i>
                    {" IDE 原生验证路径"}
                  </span>
                </div>
              </div>
              <div className="preview-column">
                <div className="preview-heading">
                  <div>
                    <span className="preview-kicker">
                      {"PRODUCT IN ACTION"}
                    </span>
                    <strong>
                      {"一项 PLC 工程任务的工作方式"}
                    </strong>
                  </div>
                  <span className="preview-hint">
                    {"点击步骤查看 · 交互示意"}
                  </span>
                </div>
                <div className="product-screen">
                  <div className="screen-top">
                    <div className="dots">
                      <b>
                      </b>
                      <b>
                      </b>
                      <b>
                      </b>
                    </div>
                    <span className="screen-name">
                      {"RealPLC · Engineering Workspace"}
                    </span>
                    <span>
                      {"◧　⋯"}
                    </span>
                  </div>
                  <div className="screen-body">
                    <div className="screen-head">
                      <span>
                        {"📁 输送线自动控制 / Demo project"}
                      </span>
                      <span className="code-pill">
                        {"CODESYS ST"}
                      </span>
                    </div>
                    <div className="screen-content">
                      <div className="smeta">
                        <span>
                          {"WORKFLOW / ENGINEERING VALIDATION"}
                        </span>
                        <span className="preview-controls">
                          <strong id="homePreviewState" aria-live="polite">
                            {"● 需求确认中"}
                          </strong>
                          <button id="homePreviewPause" type="button" aria-pressed="false" title="暂停轮播">
                            {"Ⅱ 暂停轮播"}
                          </button>
                        </span>
                      </div>
                      <div className="processline" id="homePreviewPhases" role="group" aria-label="工程演示阶段，点击查看">
                        <button type="button" className="on" data-stage-index="0" aria-current="step">
                          {"01 需求"}
                        </button>
                        <button type="button" data-stage-index="1">
                          {"02 计划"}
                        </button>
                        <button type="button" data-stage-index="2">
                          {"03 代码"}
                        </button>
                        <button type="button" data-stage-index="3">
                          {"04 验证"}
                        </button>
                      </div>
                      <div className="plant-card">
                        <div className="plant-head">
                          <span>
                            {"Conveyor line / I/O overview"}
                          </span>
                          <b id="homePreviewRun">
                            {"● REQUIREMENT REVIEW"}
                          </b>
                        </div>
                        <div className="plant-graphic" data-phase="requirements" data-fault="false" id="industrialPreview">
                          <div className="viz-labels">
                            <div className="viz-point viz-point-s01">
                              <strong>
                                {"S01"}
                              </strong>
                              <small>
                                {"光电检测"}
                              </small>
                            </div>
                            <div className="viz-point viz-point-m1">
                              <strong>
                                {"M1"}
                              </strong>
                              <small>
                                {"输送电机"}
                              </small>
                            </div>
                          </div>
                          <div className="viz-info-strip">
                            <span className="viz-status-led" id="vizStatusLed">
                            </span>
                            <span id="vizMachineStatus">
                              {"设备待命 · 电机停止"}
                            </span>
                            <span className="viz-io-badges">
                              <em id="vizSensorValue">
                                {"S01: 0"}
                              </em>
                              <em id="vizMotorValue">
                                {"M1: OFF"}
                              </em>
                              <em id="vizFaultValue">
                                {"F: 0"}
                              </em>
                            </span>
                          </div>
                          <svg className="factory-viz" viewBox="0 0 960 330" preserveAspectRatio="xMidYMid meet" role="img" aria-label="三维风格输送线示意：可见滚筒、机架、包装箱、S01 光电传感器和 M1 电机；阶段切换会改变设备演示状态">
                            <defs>
                              <linearGradient id="floorDark" x1="0" y1="0" x2="0" y2="1">
                                <stop stopColor="#1b3350">
                                </stop>
                                <stop offset="1" stopColor="#0e1b2f">
                                </stop>
                              </linearGradient>
                              <linearGradient id="rollerMetal" x1="0" x2="1" y1="0" y2="1">
                                <stop stopColor="#70889e">
                                </stop>
                                <stop offset=".18" stopColor="#283c53">
                                </stop>
                                <stop offset=".55" stopColor="#101e30">
                                </stop>
                                <stop offset=".8" stopColor="#2c4259">
                                </stop>
                                <stop offset="1" stopColor="#7791a7">
                                </stop>
                              </linearGradient>
                              <linearGradient id="steelFront" x1="0" y1="0" x2="0" y2="1">
                                <stop stopColor="#d6e5f1">
                                </stop>
                                <stop offset=".18" stopColor="#8099ad">
                                </stop>
                                <stop offset=".52" stopColor="#3d586f">
                                </stop>
                                <stop offset=".94" stopColor="#1b344c">
                                </stop>
                                <stop offset="1" stopColor="#a4b9c9">
                                </stop>
                              </linearGradient>
                              <linearGradient id="boxFront" x1="0" y1="0" x2="1" y2=".8">
                                <stop stopColor="#d6b28a">
                                </stop>
                                <stop offset=".5" stopColor="#ac8054">
                                </stop>
                                <stop offset="1" stopColor="#93643e">
                                </stop>
                              </linearGradient>
                              <linearGradient id="boxSide" x1="0" y1="0" x2="1" y2="1">
                                <stop stopColor="#9e7349">
                                </stop>
                                <stop offset="1" stopColor="#805435">
                                </stop>
                              </linearGradient>
                              <linearGradient id="boxTop" x1="0" y1="0" x2=".7" y2="1">
                                <stop stopColor="#efd1aa">
                                </stop>
                                <stop offset="1" stopColor="#bd976d">
                                </stop>
                              </linearGradient>
                              <linearGradient id="motorBlue" x1="0" y1="0" x2="1" y2="1">
                                <stop stopColor="#2a9ef4">
                                </stop>
                                <stop offset=".55" stopColor="#155eb5">
                                </stop>
                                <stop offset="1" stopColor="#11386d">
                                </stop>
                              </linearGradient>
                              <radialGradient id="sceneGlow">
                                <stop stopColor="#337cb4" stopOpacity=".32">
                                </stop>
                                <stop offset="1" stopColor="#163456" stopOpacity="0">
                                </stop>
                              </radialGradient>
                              <pattern id="tileGrid" patternUnits="userSpaceOnUse" width="58" height="45">
                                <path d="M 58 0 L 0 0 0 45" fill="none" stroke="#5a80a1" strokeOpacity=".17" strokeWidth="1">
                                </path>
                              </pattern>
                              <clipPath id="beltShape">
                                <path d="M 194 149 L 665 115 L 764 178 L 272 219 Z">
                                </path>
                              </clipPath>
                              <filter id="shadowBlur">
                                <feGaussianBlur stdDeviation="9">
                                </feGaussianBlur>
                              </filter>
                              <filter id="lightBloom">
                                <feGaussianBlur stdDeviation="5">
                                </feGaussianBlur>
                              </filter>
                            </defs>
                            <rect width="960" height="330" fill="url(#floorDark)">
                            </rect>
                            <ellipse cx="487" cy="203" rx="405" ry="155" fill="url(#sceneGlow)">
                            </ellipse>
                            <g transform="translate(0 50) skewY(-7) scale(1 .75)" opacity=".50">
                              <path d="M 0 82 H 960 V 420 H 0 Z" fill="url(#tileGrid)">
                              </path>
                            </g>
                            <ellipse cx="485" cy="275" rx="352" ry="24" fill="#010713" opacity=".55" filter="url(#shadowBlur)">
                            </ellipse>
                            <g className="conveyor-structure">
                              <g fill="url(#steelFront)" stroke="#23394f" strokeWidth="2">
                                <path d="M 261 218 L 280 219 L 280 283 L 260 283 Z">
                                </path>
                                <path d="M 403 208 L 424 207 L 425 286 L 404 287 Z">
                                </path>
                                <path d="M 622 188 L 643 186 L 643 278 L 623 280 Z">
                                </path>
                                <path d="M 746 176 L 766 174 L 766 260 L 748 263 Z">
                                </path>
                                <path d="M 245 283 L 293 283 L 303 291 L 234 291 Z">
                                </path>
                                <path d="M 391 284 L 442 284 L 451 291 L 381 291 Z">
                                </path>
                                <path d="M 608 278 L 654 278 L 664 285 L 599 285 Z">
                                </path>
                                <path d="M 734 259 L 779 258 L 789 265 L 728 266 Z">
                                </path>
                              </g>
                              <path d="M 271 254 L 408 256 L 408 263 L 271 261 Z M 417 250 L 631 245 L 632 251 L 416 257 Z M 635 241 L 755 231 L 755 239 L 635 249 Z" fill="#4e6c82" stroke="#7892a6" strokeOpacity=".55">
                              </path>
                              <path d="M 178 145 L 666 107 L 779 173 L 271 226 Z" fill="#3b536c" stroke="#92a9bf" strokeWidth="3">
                              </path>
                              <path d="M 194 149 L 665 115 L 764 178 L 272 219 Z" fill="#101d2f">
                              </path>
                              <g clipPath="url(#beltShape)" className="belt-rollers">
                                <line x1="190.0" y1="149.0" x2="274.0" y2="217.0" stroke="url(#rollerMetal)" strokeWidth="13" strokeLinecap="round" opacity=".89">
                                </line>
                                <line x1="186.0" y1="150.0" x2="270.0" y2="218.0" stroke="#b0c4d5" strokeWidth="1.8" opacity=".44">
                                </line>
                                <line x1="210.0" y1="147.6" x2="294.3" y2="215.2" stroke="url(#rollerMetal)" strokeWidth="13" strokeLinecap="round" opacity=".89">
                                </line>
                                <line x1="206.0" y1="148.6" x2="290.3" y2="216.2" stroke="#b0c4d5" strokeWidth="1.8" opacity=".44">
                                </line>
                                <line x1="230.0" y1="146.2" x2="314.7" y2="213.4" stroke="url(#rollerMetal)" strokeWidth="13" strokeLinecap="round" opacity=".89">
                                </line>
                                <line x1="226.0" y1="147.2" x2="310.7" y2="214.4" stroke="#b0c4d5" strokeWidth="1.8" opacity=".44">
                                </line>
                                <line x1="250.0" y1="144.8" x2="335.0" y2="211.6" stroke="url(#rollerMetal)" strokeWidth="13" strokeLinecap="round" opacity=".89">
                                </line>
                                <line x1="246.0" y1="145.8" x2="331.0" y2="212.6" stroke="#b0c4d5" strokeWidth="1.8" opacity=".44">
                                </line>
                                <line x1="270.0" y1="143.3" x2="355.3" y2="209.8" stroke="url(#rollerMetal)" strokeWidth="13" strokeLinecap="round" opacity=".89">
                                </line>
                                <line x1="266.0" y1="144.3" x2="351.3" y2="210.8" stroke="#b0c4d5" strokeWidth="1.8" opacity=".44">
                                </line>
                                <line x1="290.0" y1="141.9" x2="375.7" y2="208.0" stroke="url(#rollerMetal)" strokeWidth="13" strokeLinecap="round" opacity=".89">
                                </line>
                                <line x1="286.0" y1="142.9" x2="371.7" y2="209.0" stroke="#b0c4d5" strokeWidth="1.8" opacity=".44">
                                </line>
                                <line x1="310.0" y1="140.5" x2="396.0" y2="206.2" stroke="url(#rollerMetal)" strokeWidth="13" strokeLinecap="round" opacity=".89">
                                </line>
                                <line x1="306.0" y1="141.5" x2="392.0" y2="207.2" stroke="#b0c4d5" strokeWidth="1.8" opacity=".44">
                                </line>
                                <line x1="330.0" y1="139.1" x2="416.3" y2="204.5" stroke="url(#rollerMetal)" strokeWidth="13" strokeLinecap="round" opacity=".89">
                                </line>
                                <line x1="326.0" y1="140.1" x2="412.3" y2="205.5" stroke="#b0c4d5" strokeWidth="1.8" opacity=".44">
                                </line>
                                <line x1="350.0" y1="137.7" x2="436.7" y2="202.7" stroke="url(#rollerMetal)" strokeWidth="13" strokeLinecap="round" opacity=".89">
                                </line>
                                <line x1="346.0" y1="138.7" x2="432.7" y2="203.7" stroke="#b0c4d5" strokeWidth="1.8" opacity=".44">
                                </line>
                                <line x1="370.0" y1="136.2" x2="457.0" y2="200.9" stroke="url(#rollerMetal)" strokeWidth="13" strokeLinecap="round" opacity=".89">
                                </line>
                                <line x1="366.0" y1="137.2" x2="453.0" y2="201.9" stroke="#b0c4d5" strokeWidth="1.8" opacity=".44">
                                </line>
                                <line x1="390.0" y1="134.8" x2="477.3" y2="199.1" stroke="url(#rollerMetal)" strokeWidth="13" strokeLinecap="round" opacity=".89">
                                </line>
                                <line x1="386.0" y1="135.8" x2="473.3" y2="200.1" stroke="#b0c4d5" strokeWidth="1.8" opacity=".44">
                                </line>
                                <line x1="410.0" y1="133.4" x2="497.7" y2="197.3" stroke="url(#rollerMetal)" strokeWidth="13" strokeLinecap="round" opacity=".89">
                                </line>
                                <line x1="406.0" y1="134.4" x2="493.7" y2="198.3" stroke="#b0c4d5" strokeWidth="1.8" opacity=".44">
                                </line>
                                <line x1="430.0" y1="132.0" x2="518.0" y2="195.5" stroke="url(#rollerMetal)" strokeWidth="13" strokeLinecap="round" opacity=".89">
                                </line>
                                <line x1="426.0" y1="133.0" x2="514.0" y2="196.5" stroke="#b0c4d5" strokeWidth="1.8" opacity=".44">
                                </line>
                                <line x1="450.0" y1="130.6" x2="538.3" y2="193.7" stroke="url(#rollerMetal)" strokeWidth="13" strokeLinecap="round" opacity=".89">
                                </line>
                                <line x1="446.0" y1="131.6" x2="534.3" y2="194.7" stroke="#b0c4d5" strokeWidth="1.8" opacity=".44">
                                </line>
                                <line x1="470.0" y1="129.2" x2="558.7" y2="191.9" stroke="url(#rollerMetal)" strokeWidth="13" strokeLinecap="round" opacity=".89">
                                </line>
                                <line x1="466.0" y1="130.2" x2="554.7" y2="192.9" stroke="#b0c4d5" strokeWidth="1.8" opacity=".44">
                                </line>
                                <line x1="490.0" y1="127.8" x2="579.0" y2="190.1" stroke="url(#rollerMetal)" strokeWidth="13" strokeLinecap="round" opacity=".89">
                                </line>
                                <line x1="486.0" y1="128.8" x2="575.0" y2="191.1" stroke="#b0c4d5" strokeWidth="1.8" opacity=".44">
                                </line>
                                <line x1="510.0" y1="126.3" x2="599.3" y2="188.3" stroke="url(#rollerMetal)" strokeWidth="13" strokeLinecap="round" opacity=".89">
                                </line>
                                <line x1="506.0" y1="127.3" x2="595.3" y2="189.3" stroke="#b0c4d5" strokeWidth="1.8" opacity=".44">
                                </line>
                                <line x1="530.0" y1="124.9" x2="619.7" y2="186.5" stroke="url(#rollerMetal)" strokeWidth="13" strokeLinecap="round" opacity=".89">
                                </line>
                                <line x1="526.0" y1="125.9" x2="615.7" y2="187.5" stroke="#b0c4d5" strokeWidth="1.8" opacity=".44">
                                </line>
                                <line x1="550.0" y1="123.5" x2="640.0" y2="184.8" stroke="url(#rollerMetal)" strokeWidth="13" strokeLinecap="round" opacity=".89">
                                </line>
                                <line x1="546.0" y1="124.5" x2="636.0" y2="185.8" stroke="#b0c4d5" strokeWidth="1.8" opacity=".44">
                                </line>
                                <line x1="570.0" y1="122.1" x2="660.3" y2="183.0" stroke="url(#rollerMetal)" strokeWidth="13" strokeLinecap="round" opacity=".89">
                                </line>
                                <line x1="566.0" y1="123.1" x2="656.3" y2="184.0" stroke="#b0c4d5" strokeWidth="1.8" opacity=".44">
                                </line>
                                <line x1="590.0" y1="120.7" x2="680.7" y2="181.2" stroke="url(#rollerMetal)" strokeWidth="13" strokeLinecap="round" opacity=".89">
                                </line>
                                <line x1="586.0" y1="121.7" x2="676.7" y2="182.2" stroke="#b0c4d5" strokeWidth="1.8" opacity=".44">
                                </line>
                                <line x1="610.0" y1="119.2" x2="701.0" y2="179.4" stroke="url(#rollerMetal)" strokeWidth="13" strokeLinecap="round" opacity=".89">
                                </line>
                                <line x1="606.0" y1="120.2" x2="697.0" y2="180.4" stroke="#b0c4d5" strokeWidth="1.8" opacity=".44">
                                </line>
                                <line x1="630.0" y1="117.8" x2="721.3" y2="177.6" stroke="url(#rollerMetal)" strokeWidth="13" strokeLinecap="round" opacity=".89">
                                </line>
                                <line x1="626.0" y1="118.8" x2="717.3" y2="178.6" stroke="#b0c4d5" strokeWidth="1.8" opacity=".44">
                                </line>
                                <line x1="650.0" y1="116.4" x2="741.7" y2="175.8" stroke="url(#rollerMetal)" strokeWidth="13" strokeLinecap="round" opacity=".89">
                                </line>
                                <line x1="646.0" y1="117.4" x2="737.7" y2="176.8" stroke="#b0c4d5" strokeWidth="1.8" opacity=".44">
                                </line>
                                <line x1="670.0" y1="115.0" x2="762.0" y2="174.0" stroke="url(#rollerMetal)" strokeWidth="13" strokeLinecap="round" opacity=".89">
                                </line>
                                <line x1="666.0" y1="116.0" x2="758.0" y2="175.0" stroke="#b0c4d5" strokeWidth="1.8" opacity=".44">
                                </line>
                              </g>
                              <path d="M 174 140 L 661 103 L 671 112 L 184 149 Z" fill="url(#steelFront)" stroke="#adc0d1" strokeOpacity=".5">
                              </path>
                              <path d="M 268 219 L 762 177 L 787 191 L 277 237 Z" fill="url(#steelFront)" stroke="#a6bdcf" strokeWidth="2">
                              </path>
                              <path d="M 278 237 L 785 190 L 786 202 L 279 248 Z" fill="#243e56" stroke="#56728d" strokeWidth="2">
                              </path>
                              <g fill="#a7bbca" stroke="#284158" strokeWidth="1">
                                <circle cx="305" cy="229" r="4">
                                </circle>
                                <circle cx="430" cy="218" r="4">
                                </circle>
                                <circle cx="571" cy="205" r="4">
                                </circle>
                                <circle cx="709" cy="194" r="4">
                                </circle>
                              </g>
                            </g>
                            <g className="moving-arrows" clipPath="url(#beltShape)" opacity="0">
                              <path d="M385 168 l12 -7 l-1 7 l12 1 l-13 7 l1 -7Z M423 165 l12 -7 l-1 7 l12 1 l-13 7 l1 -7Z M461 162 l12 -7 l-1 7 l12 1 l-13 7 l1 -7Z M499 159 l12 -7 l-1 7 l12 1 l-13 7 l1 -7Z M537 156 l12 -7 l-1 7 l12 1 l-13 7 l1 -7Z" fill="#57d9f4" opacity=".85" stroke="#6bf4ff" strokeWidth="1.1">
                              </path>
                            </g>
                            <g className="tracked-box" transform="translate(-135 0)">
                              <ellipse cx="369" cy="188" rx="74" ry="16" fill="#050d1b" opacity=".55" filter="url(#shadowBlur)">
                              </ellipse>
                              <path d="M 307 116 L 353 96 L 420 120 L 372 142 Z" fill="url(#boxTop)" stroke="#e3c7a4" strokeWidth="1">
                              </path>
                              <path d="M 307 116 L 372 142 L 372 194 L 306 168 Z" fill="url(#boxFront)">
                              </path>
                              <path d="M 372 142 L 420 120 L 420 173 L 372 194 Z" fill="url(#boxSide)">
                              </path>
                              <path d="M 353 96 L 368 101 L 381 136 L 369 140 L 349 101 Z" fill="#ebd6b7" opacity=".84">
                              </path>
                              <path d="M 368 140 L 382 136 L 382 189 L 368 193 Z" fill="#dcc19d" opacity=".6">
                              </path>
                              <path d="M 322 157 L 347 167 L 347 178 L 322 168 Z" fill="#415267" opacity=".47">
                              </path>
                              <path d="M 326 159 L 344 166 M 326 163 L 344 170" stroke="#f0e3d1" strokeWidth="2" strokeDasharray="2 2">
                              </path>
                            </g>
                            <g className="s01-hardware" transform="translate(0 0)">
                              <path d="M208 174 L225 176 L225 268 L208 266Z" fill="url(#steelFront)" stroke="#1b354c" strokeWidth="2">
                              </path>
                              <path d="M197 269 L237 269 L247 277 L191 277Z" fill="#6d869c">
                              </path>
                              <path d="M190 132 Q189 128 195 127 L226 127 Q232 129 231 135 L231 169 L191 169 Z" fill="#27384b" stroke="#92aabc" strokeWidth="2">
                              </path>
                              <rect x="198" y="138" width="20" height="22" rx="3" fill="#1a2636" stroke="#72899c">
                              </rect>
                              <circle className="sensor-led" cx="208" cy="149" r="7" fill="#6d8696">
                              </circle>
                              <path className="sensor-beam-light" d="M 216 150 L 271 149" stroke="#ff6258" strokeWidth="2" opacity="0">
                              </path>
                            </g>
                            <g className="m1-hardware">
                              <path d="M776 239 L823 236 L831 242 L782 247Z" fill="#576f87" stroke="#8c9fb1">
                              </path>
                              <path d="M 789 197 L810 197 L811 243 L792 243 Z" fill="url(#steelFront)">
                              </path>
                              <path d="M 767 147 Q770 142 777 143 L819 143 Q825 145 825 153 L825 194 Q822 201 814 201 L775 201 Q767 198 767 191 Z" fill="url(#motorBlue)" stroke="#1f69b4" strokeWidth="2">
                              </path>
                              <rect x="807" y="151" width="70" height="42" rx="18" fill="#203c54" stroke="#6a8ba1" strokeWidth="2">
                              </rect>
                              <g stroke="#607f98" strokeWidth="3" opacity=".72">
                                <path d="M820 155V189 M830 154V191 M841 153V192 M852 154V192 M861 155V190">
                                </path>
                              </g>
                              <ellipse cx="878" cy="172" rx="20" ry="22" fill="#182d43" stroke="#4d6b83" strokeWidth="3">
                              </ellipse>
                              <ellipse cx="882" cy="172" rx="9" ry="13" fill="#0a1b2b" stroke="#435a72">
                              </ellipse>
                              <circle className="motor-led" cx="875" cy="146" r="6" fill="#637887">
                              </circle>
                              <path d="M 785 142 L 785 125 L 807 125 L 807 141" fill="none" stroke="#83a1b7" strokeWidth="3">
                              </path>
                            </g>
                            <g className="plan-overlay" opacity="0">
                              <path d="M 181 133 L 668 95 L 800 174 L 271 248 Z" fill="none" stroke="#42d5e5" strokeWidth="2" strokeDasharray="11 7">
                              </path>
                              <path d="M194 286 L252 286 M700 286 L763 286" stroke="#43c6e4" strokeWidth="1.5" strokeDasharray="5 5">
                              </path>
                            </g>
                          </svg>
                          <div className="viz-watermark">
                            {"交互示意 · 非真实 PLC 仿真"}
                          </div>
                        </div>
                        <div className="sim-toolbar" id="simToolbar" hidden={true} aria-label="验证演示控制">
                          <div className="sim-toolbar-label">
                            <span className="sim-label-dot">
                            </span>
                            <strong>
                              {"验证演示"}
                            </strong>
                            <span className="sim-tag">
                              {"SIMULATION ONLY"}
                            </span>
                          </div>
                          <div className="sim-toolbar-actions">
                            <label htmlFor="simSpeed">
                              {"速度"}
                            </label>
                            <select id="simSpeed" aria-label="演示输送速度" defaultValue="1">
                              <option value="0.7">
                                {"0.7×"}
                              </option>
                              <option value="1">
                                {"1.0×"}
                              </option>
                              <option value="1.5">
                                {"1.5×"}
                              </option>
                            </select>
                            <button type="button" id="simFaultBtn" className="sim-fault-btn">
                              {"模拟过载"}
                            </button>
                            <button type="button" id="simResetBtn" className="sim-reset-btn" disabled={true}>
                              {"故障复位"}
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="screen-cols">
                        <div className="mini-panel">
                          <strong id="homePreviewLeftTitle">
                            {"↳ 需求摘要 / Requirement"}
                          </strong>
                          <p id="homePreviewLeftText">
                            {"确认启停、起始检测、允许条件与电机输出的边界。"}
                          </p>
                        </div>
                        <div className="mini-panel">
                          <strong id="homePreviewRightTitle">
                            {"↳ 当前说明 / Demo"}
                          </strong>
                          <p id="homePreviewRightText" className="success">
                            {"等待将需求整理为可审批的工程计划。"}
                          </p>
                          <div className="sim-event-area" id="simEventArea" hidden={true}>
                            <div className="sim-event-head">
                              <span>
                                {"运行事件（模拟）"}
                              </span>
                              <span id="simObjectCounter">
                                {"通过 0 件"}
                              </span>
                            </div>
                            <div className="sim-event-list" id="simEventList" aria-live="off">
                              <span>
                                {"等待事件…"}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="screen-foot">
                      <span id="homePreviewFoot">
                        {"Requirement / 输送线自动控制 #REQ-104"}
                      </span>
                      <span className="tick" id="homePreviewTick">
                        {"● 对齐约束与验收标准"}
                      </span>
                    </div>
                  </div>
                  <div className="screen-caption">
                    <span>
                      {"真实 IDE 结果需要连接本地 Agent · 上图为产品交互示意"}
                    </span>
                    <span id="homePreviewPage">
                      {"01 / 04"}
                    </span>
                  </div>
                </div>
                <div className="floating-note">
                  <span className="round-check">
                    {"✓"}
                  </span>
                  <strong id="homePreviewFloatTitle">
                    {"先确认需求边界"}
                  </strong>
                  <small id="homePreviewFloatText">
                    {"需求、变量与验证目标先对齐"}
                  </small>
                </div>
                <div className="preview-below">
                  <span>
                    {"独立示例数据 · 原生编译以本地 Agent 返回结果为准"}
                  </span>
                  <a href="https://github.com/JadeHuang/RealPLC-Agent" target="_blank" rel="noopener noreferrer">
                    {"查看 Agent GitHub ↗"}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="home-proof" aria-label="RealPLC 工程优势">
          <div className="container home-proof-grid">
            <div>
              <span className="proof-index">
                {"01 / CONTEXT"}
              </span>
              <strong>
                {"工程上下文持续保留"}
              </strong>
              <small>
                {"需求、决策与工件关联，不从头重复沟通。"}
              </small>
            </div>
            <div>
              <span className="proof-index">
                {"02 / REVIEW"}
              </span>
              <strong>
                {"关键变更先经审批"}
              </strong>
              <small>
                {"代码生成、修改与验证计划有记录。"}
              </small>
            </div>
            <div>
              <span className="proof-index">
                {"03 / VALIDATION"}
              </span>
              <strong>
                {"原生编译返回证据"}
              </strong>
              <small>
                {"通过本地 Agent 对接 TIA Portal / CODESYS。"}
              </small>
            </div>
          </div>
        </section>
        <section className="section" id="scenarios">
          <div className="container">
            <div className="section-head">
              <div>
                <div className="eyebrow">
                  {"CHOOSE A REAL TASK"}
                </div>
                <h2>
                  {"从熟悉的设备开始。"}
                </h2>
              </div>
              <p>
                {"选择一个场景，查看从控制需求到编译验证的工程流程。"}
              </p>
            </div>
            <div className="scene-grid" id="sceneCards">
              <article className="scene-card" data-scene="conveyor" role="button" tabIndex={0}>
                <div className="scene-top">
                  <span>
                    {"01 / MATERIAL HANDLING"}
                  </span>
                  <span>
                    {"ST · SCL"}
                  </span>
                </div>
                <div className="scene-visual">
                  <svg fill="none" viewBox="0 0 200 85">
                    <rect fill="#d0e4f4" height="28" rx="14" stroke="#377fb5" strokeWidth="2" width="164" x="18" y="39">
                    </rect>
                    <path d="M28 53H172" stroke="#79aac9" strokeDasharray="8 9" strokeWidth="6">
                    </path>
                    <rect fill="#86c4e9" height="25" rx="4" stroke="#377fb5" strokeWidth="2" width="30" x="50" y="17">
                    </rect>
                    <rect fill="#8fcde6" height="29" rx="5" stroke="#377fb5" strokeWidth="2" width="25" x="135" y="9">
                    </rect>
                    <circle cx="20" cy="53" fill="#fff" r="9" stroke="#3874a2" strokeWidth="3">
                    </circle>
                    <circle cx="180" cy="53" fill="#fff" r="9" stroke="#3874a2" strokeWidth="3">
                    </circle>
                  </svg>
                </div>
                <h3>
                  {"输送线启停"}
                </h3>
                <p>
                  {"启动许可、急停、过载、反馈超时与人工复位"}
                </p>
                <span className="scene-go">
                  {"查看工程演示 →"}
                </span>
              </article>
              <article className="scene-card" data-scene="motor" role="button" tabIndex={0}>
                <div className="scene-top">
                  <span>
                    {"02 / MOTOR CONTROL"}
                  </span>
                  <span>
                    {"ST · SCL"}
                  </span>
                </div>
                <div className="scene-visual">
                  <svg fill="none" viewBox="0 0 200 85">
                    <rect fill="#aad0e7" height="53" rx="10" stroke="#317caf" strokeWidth="2" width="96" x="49" y="16">
                    </rect>
                    <path d="M68 18V69M83 18V69M98 18V69" stroke="#5a9ec6" strokeWidth="3">
                    </path>
                    <rect fill="#4085aa" height="12" rx="3" width="27" x="145" y="36">
                    </rect>
                    <circle cx="157" cy="24" fill="#28ceb0" r="7">
                    </circle>
                    <path d="M27 30V57M21 44H35" stroke="#3986bb" strokeWidth="4">
                    </path>
                  </svg>
                </div>
                <h3>
                  {"电机与联锁"}
                </h3>
                <p>
                  {"自动/手动切换、故障锁存、热继电器与安全恢复"}
                </p>
                <span className="scene-go">
                  {"查看工程演示 →"}
                </span>
              </article>
              <article className="scene-card" data-scene="mixer" role="button" tabIndex={0}>
                <div className="scene-top">
                  <span>
                    {"03 / PROCESS CONTROL"}
                  </span>
                  <span>
                    {"SEQUENCE"}
                  </span>
                </div>
                <div className="scene-visual">
                  <svg fill="none" viewBox="0 0 200 85">
                    <path d="M57 19H146V53L121 70H83L57 53Z" fill="#c8e4f6" stroke="#3682b5" strokeWidth="2">
                    </path>
                    <path d="M62 45H140V53L119 65H84L62 53Z" fill="#82cce8">
                    </path>
                    <path d="M100 5V55M86 42L114 28M86 28L114 42" stroke="#3f8fb8" strokeWidth="4">
                    </path>
                    <rect fill="#418bad" height="11" rx="3" width="20" x="91" y="3">
                    </rect>
                    <path d="M59 20H43V10M143 20H160V10" stroke="#3f8fb8" strokeWidth="3">
                    </path>
                  </svg>
                </div>
                <h3>
                  {"批次混料顺控"}
                </h3>
                <p>
                  {"进料、混合、排料工步及超时异常处理"}
                </p>
                <span className="scene-go">
                  {"查看工程演示 →"}
                </span>
              </article>
              <article className="scene-card" data-scene="alarm" role="button" tabIndex={0}>
                <div className="scene-top">
                  <span>
                    {"04 / ALARM MANAGEMENT"}
                  </span>
                  <span>
                    {"DIAGNOSIS"}
                  </span>
                </div>
                <div className="scene-visual">
                  <svg fill="none" viewBox="0 0 200 85">
                    <rect fill="#dceaf7" height="61" rx="8" stroke="#3f85b8" strokeWidth="2" width="126" x="37" y="13">
                    </rect>
                    <path d="M48 31H152M48 47H152M48 63H152" stroke="#7fb5d3" strokeWidth="2">
                    </path>
                    <circle cx="57" cy="23" fill="#ffb36f" r="5">
                    </circle>
                    <circle cx="57" cy="39" fill="#38c9ab" r="5">
                    </circle>
                    <circle cx="57" cy="55" fill="#e99c61" r="5">
                    </circle>
                    <path d="M70 23H136M70 39H121M70 55H145" stroke="#6a9cbc" strokeLinecap="round" strokeWidth="4">
                    </path>
                  </svg>
                </div>
                <h3>
                  {"设备报警矩阵"}
                </h3>
                <p>
                  {"报警触发、确认、复位、蜂鸣器及优先级"}
                </p>
                <span className="scene-go">
                  {"查看工程演示 →"}
                </span>
              </article>
            </div>
          </div>
        </section>
        <section className="section diff-section" id="workflow">
          <div className="container">
            <div className="section-head center">
              <div className="eyebrow">
                {"FROM PROMPT TO PROOF"}
              </div>
              <h2>
                {"从需求到验证，一条清晰的工程链路。"}
              </h2>
              <p>
                {"工程师掌握决策，AI 加速执行，结果由原生工具检验。"}
              </p>
            </div>
            <div className="flow-grid">
              <div className="flowcard">
                <span className="n">
                  {"STAGE / 01"}
                </span>
                <span className="icon">
                  {"◈"}
                </span>
                <h3>
                  {"明确控制需求"}
                </h3>
                <p>
                  {"补足 I/O、运行条件、联锁、报警、恢复等工程约束。"}
                </p>
                <b className="soft">
                  {"需求确认"}
                </b>
              </div>
              <div className="flowcard">
                <span className="n">
                  {"STAGE / 02"}
                </span>
                <span className="icon">
                  {"▤"}
                </span>
                <h3>
                  {"审查实施计划"}
                </h3>
                <p>
                  {"先看状态与逻辑分解，关键决策由工程师把关。"}
                </p>
                <b className="soft">
                  {"人工审批"}
                </b>
              </div>
              <div className="flowcard">
                <span className="n">
                  {"STAGE / 03"}
                </span>
                <span className="icon">
                  {"⌘"}
                </span>
                <h3>
                  {"生成 PLC 工件"}
                </h3>
                <p>
                  {"面向选定平台生成 ST/SCL，并保留上下文及版本。"}
                </p>
                <b>
                  {"代码工件"}
                </b>
              </div>
              <div className="flowcard">
                <span className="n">
                  {"STAGE / 04"}
                </span>
                <span className="icon">
                  {"◇"}
                </span>
                <h3>
                  {"进入原生 IDE"}
                </h3>
                <p>
                  {"通过本地 Agent 接入 TIA Portal 或 CODESYS 的工程验证流程。"}
                </p>
                <b>
                  {"真实编译器"}
                </b>
              </div>
              <div className="flowcard">
                <span className="n">
                  {"STAGE / 05"}
                </span>
                <span className="icon">
                  {"↻"}
                </span>
                <h3>
                  {"诊断、修复、复验"}
                </h3>
                <p>
                  {"将编译诊断反馈给 AI 和工程师，保留修复路径及记录。"}
                </p>
                <b>
                  {"结果可追溯"}
                </b>
              </div>
            </div>
          </div>
        </section>
        <section className="section agent-section" id="agent" aria-labelledby="agentHeadline">
          <div className="container agent-layout">
            <div className="agent-copy">
              <div className="agent-eyebrow">
                <i aria-hidden="true">
                </i>
                {" REALPLC AGENT · LOCAL VERIFICATION"}
              </div>
              <h2 id="agentHeadline">
                {"AI 生成代码，"}
                <br />
                <em>
                  {"真实工程软件验证。"}
                </em>
              </h2>
              <p className="agent-desc">
                {"RealPLC Agent 是安装在 Windows 工程电脑上的本地连接组件。将 AI 生成的 ST / SCL 候选程序送入 "}
                <strong>
                  {"TIA Portal"}
                </strong>
                {" 或 "}
                <strong>
                  {"CODESYS"}
                </strong>
                {" 的工程环境，获取原生编译诊断，再用于分析、修复与复验。"}
              </p>
              <div className="agent-capabilities" aria-label="Agent 适用环境">
                <span>
                  {"Windows x64"}
                </span>
                <span>
                  {"Siemens TIA Portal / Openness"}
                </span>
                <span>
                  {"CODESYS / Scripting"}
                </span>
              </div>
              <div className="agent-buttons">
                <a className="agent-button primary" href={AGENT_DOWNLOAD_URL} target="_blank" rel="noopener noreferrer" aria-label="立即下载 RealPLC Agent Windows 安装包">
                  {"立即下载 "}
                  <span aria-hidden="true">
                    {"↗"}
                  </span>
                </a>
                <a className="agent-button outline" href="https://github.com/JadeHuang/RealPLC-Agent/releases/latest" target="_blank" rel="noopener noreferrer" aria-label="GitHub 备用下载 RealPLC Agent">
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M12 1.3A10.7 10.7 0 0 0 8.62 22.15c.54.1.74-.24.74-.52v-2.02c-3.01.66-3.64-1.27-3.64-1.27-.49-1.24-1.2-1.57-1.2-1.57-.98-.67.08-.65.08-.65 1.08.07 1.65 1.11 1.65 1.11.96 1.64 2.53 1.17 3.15.9.1-.7.38-1.18.69-1.45-2.4-.28-4.93-1.2-4.93-5.29 0-1.17.42-2.13 1.1-2.88-.11-.27-.48-1.36.11-2.84 0 0 .9-.29 2.94 1.1a10.1 10.1 0 0 1 5.35 0c2.03-1.39 2.93-1.1 2.93-1.1.59 1.48.22 2.57.11 2.84.69.75 1.1 1.71 1.1 2.88 0 4.1-2.54 5.01-4.96 5.28.39.34.73 1.02.73 2.06v3.06c0 .28.2.63.74.52A10.7 10.7 0 0 0 12 1.3Z">
                    </path>
                  </svg>
                  {"\n          GitHub 备用下载 "}
                  <span aria-hidden="true">
                    {"↗"}
                  </span>
                </a>
              </div>
              <p className="agent-caveat">
                {"优先使用云端下载，GitHub 为备用通道。请先在测试工程或副本中验证。"}
              </p>
            </div>
            <div className="agent-diagram" aria-label="原生验证闭环流程图：RealPLC AI 通过 Windows Agent 连接 TIA Portal 或 CODESYS，并获取诊断回传">
              <div className="agent-diagram-top">
                <div className="agent-window-title">
                  <span className="agent-lights" aria-hidden="true">
                    <i>
                    </i>
                    <i>
                    </i>
                    <i>
                    </i>
                  </span>
                  {" 原生工程验证链路"}
                </div>
                <span className="agent-version-pill">
                  {"Windows 本地 Agent"}
                </span>
              </div>
              <div className="agent-diagram-body">
                <div className="agent-bridge">
                  <div className="agent-node">
                    <span className="agent-node-mark" aria-hidden="true">
                      {"AI"}
                    </span>
                    <strong className="agent-node-label">
                      {"RealPLC AI"}
                    </strong>
                    <span className="agent-node-sub">
                      {"生成 ST / SCL"}
                    </span>
                  </div>
                  <div className="agent-bridge-arrow" aria-hidden="true">
                    {"→"}
                  </div>
                  <div className="agent-node local">
                    <span className="agent-node-mark" aria-hidden="true">
                      {"↔"}
                    </span>
                    <strong className="agent-node-label">
                      {"RealPLC Agent"}
                    </strong>
                    <span className="agent-node-sub">
                      {"Windows 本地连接"}
                    </span>
                  </div>
                  <div className="agent-bridge-arrow" aria-hidden="true">
                    {"→"}
                  </div>
                  <div className="agent-ide-pair">
                    <div>
                      <strong>
                        {"TIA Portal"}
                      </strong>
                      <span>
                        {"Openness / Compile"}
                      </span>
                    </div>
                    <div>
                      <strong>
                        {"CODESYS"}
                      </strong>
                      <span>
                        {"Scripting / Compile"}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="agent-return">
                  <span>
                    {"原生编译结果 / Diagnostics 回传 ↶"}
                  </span>
                </div>
                <div className="agent-result">
                  <span className="agent-result-icon" aria-hidden="true">
                    {"↻"}
                  </span>
                  <div className="agent-result-text">
                    <strong>
                      {"发现问题 → 修复候选 → 再次验证"}
                    </strong>
                    <p>
                      {"依据 IDE 诊断迭代，而不是只相信模型自检结果"}
                    </p>
                  </div>
                </div>
              </div>
              <div className="agent-diagram-foot">
                <span>
                  {"流程说明 · 非实时设备连接画面"}
                </span>
                <span>
                  {"Generate → Validate → Fix"}
                </span>
              </div>
            </div>
          </div>
        </section>
        <section aria-labelledby="ecoTitle" className="eco-section" id="ecosystem">
          <div className="container">
            <div className="eco-header">
              <div className="eco-intro">
                <div className="eyebrow">
                  <span className="eco-eyebrow-dot">
                  </span>
                  {" ENGINEERING ECOSYSTEM"}
                </div>
                <h2 id="ecoTitle">
                  {"连接熟悉的工业生态。"}
                </h2>
                <p>
                  {"优先对接 TIA Portal 与 CODESYS，按平台、版本与本地环境使用。"}
                </p>
              </div>
              <div className="eco-toggle-wrap">
                <div aria-label="切换生态展示方式" className="eco-switch" role="group">
                  <button aria-pressed="true" className="selected" data-eco-mode="a" id="ecoModeA" type="button">
                    <i aria-hidden="true">
                      {"≡"}
                    </i>
                    {" 平台概览"}
                  </button>
                  <button aria-pressed="false" data-eco-mode="b" id="ecoModeB" type="button">
                    <i aria-hidden="true">
                      {"▦"}
                    </i>
                    {" 兼容详情"}
                  </button>
                </div>
              </div>
            </div>
            <div aria-label="工业平台概览" className="eco-variant" id="ecoViewA">
              <div className="eco-logo-grid">
                <button aria-label="查看 Siemens 适配范围" className="logo-tile" data-vendor="siemens" type="button">
                  <span className="vmark vm-siemens">
                    <span className="vword siemens">
                      {"SIEMENS"}
                    </span>
                  </span>
                  <span className="tile-status ready">
                    <b>
                      {"●"}
                    </b>
                    {" 已对接原生验证"}
                  </span>
                </button>
                <button aria-label="查看 CODESYS 适配范围" className="logo-tile" data-vendor="codesys" type="button">
                  <span className="vmark vm-codesys">
                    <svg aria-hidden="true" viewBox="0 0 26 25">
                      <path d="M2 6.6 13 1l11 5.6-11 5.7z" fill="#a9b3c2">
                      </path>
                      <path d="M2 6.6 13 12.3v11.1L2 17.3z" fill="#e2ebf7">
                      </path>
                      <path d="M13 12.3 24 6.6v10.7l-11 6.1z" fill="#c90015">
                      </path>
                    </svg>
                    <span className="vword codesys">
                      {"CODESYS"}
                    </span>
                  </span>
                  <span className="tile-status ready">
                    <b>
                      {"●"}
                    </b>
                    {" 已对接原生验证"}
                  </span>
                </button>
                <button aria-label="查看 欧姆龙 适配范围" className="logo-tile" data-vendor="omron" type="button">
                  <span className="vmark vm-omron">
                    <span className="vword omron">
                      {"OMRON"}
                    </span>
                  </span>
                  <span className="tile-status roadmap">
                    <b>
                      {"◌"}
                    </b>
                    {" 适配评估中"}
                  </span>
                </button>
                <button aria-label="查看 汇川技术 适配范围" className="logo-tile" data-vendor="inovance" type="button">
                  <span className="vmark vm-inovance">
                    <span className="vword inovance">
                      {"INOVANCE"}
                    </span>
                    <small>
                      {"汇川技术"}
                    </small>
                  </span>
                  <span className="tile-status roadmap">
                    <b>
                      {"◌"}
                    </b>
                    {" 适配评估中"}
                  </span>
                </button>
                <button aria-label="查看 三菱电机 适配范围" className="logo-tile" data-vendor="mitsubishi" type="button">
                  <span className="vmark vm-mitsubishi">
                    <svg aria-hidden="true" viewBox="0 0 39 30">
                      <path d="M19.5 1 10.7 15.7h17.6zM9.1 17.3.4 29h17.5zM29.9 17.3 21 29h17.6z" fill="#ef273e">
                      </path>
                    </svg>
                    <span className="vword mitsubishi">
                      {"MITSUBISHI "}
                      <small>
                        {"ELECTRIC"}
                      </small>
                    </span>
                  </span>
                  <span className="tile-status roadmap">
                    <b>
                      {"◌"}
                    </b>
                    {" 生态调研"}
                  </span>
                </button>
                <button aria-label="查看 施耐德电气 适配范围" className="logo-tile" data-vendor="schneider" type="button">
                  <span className="vmark vm-schneider">
                    <span className="vword schneider">
                      {"Schneider"}
                      <small>
                        {"Electric"}
                      </small>
                    </span>
                  </span>
                  <span className="tile-status roadmap">
                    <b>
                      {"◌"}
                    </b>
                    {" 生态调研"}
                  </span>
                </button>
              </div>
              <div className="eco-mininote">
                <a data-eco-mode="b" href="#ecosystem">
                  {"查看详细兼容状态  ↗"}
                </a>
              </div>
            </div>
            <div aria-label="方案 B：Logo 和兼容矩阵" className="eco-variant" hidden={true} id="ecoViewB">
              <div className="eco-stats">
                <div className="eco-stat first">
                  <span className="eco-stat-icon">
                    {"◇"}
                  </span>
                  <span className="eco-stat-value">
                    {"02"}
                  </span>
                  <div>
                    <b>
                      {"重点验证生态"}
                    </b>
                    <small>
                      {"TIA Portal / CODESYS"}
                    </small>
                  </div>
                </div>
                <div className="eco-stat">
                  <span className="eco-stat-value">
                    {"06"}
                  </span>
                  <div>
                    <b>
                      {"适配与研究方向"}
                    </b>
                    <small>
                      {"不等于当前已支持"}
                    </small>
                  </div>
                </div>
                <div className="eco-stat-note">
                  {"请根据实际版本、工程软件及 Agent 能力判定兼容性，演示不替代平台认证。"}
                </div>
              </div>
              <div className="eco-matrix-layout">
                <div className="eco-matrix-main">
                  <div className="eco-matrix-top">
                    <div>
                      <strong>
                        {"平台兼容能力"}
                      </strong>
                      <small>
                        {"单击厂商查看说明"}
                      </small>
                    </div>
                    <div aria-label="筛选厂商" className="eco-filters" role="group">
                      <button aria-pressed="true" className="is-active" data-eco-filter="all" type="button">
                        {"全部 8"}
                      </button>
                      <button aria-pressed="false" data-eco-filter="core" type="button">
                        {"核心 2"}
                      </button>
                      <button aria-pressed="false" data-eco-filter="future" type="button">
                        {"扩展 6"}
                      </button>
                    </div>
                  </div>
                  <div className="eco-mobile-scrollhint">
                    {"← 横向滑动，查看全部能力列 →"}
                  </div>
                  <div className="eco-matrix-scroll">
                    <div className="eco-matrix-table">
                      <div className="matrix-head">
                        <span>
                          {"平台 / 编程环境"}
                        </span>
                        <span>
                          {"代码生成"}
                        </span>
                        <span>
                          {"原生编译"}
                        </span>
                        <span>
                          {"Agent 连接"}
                        </span>
                        <span>
                          {"能力状态"}
                        </span>
                        <span>
                        </span>
                      </div>
                      <button aria-pressed="true" className="matrix-row is-current" data-kind="core" data-vendor="siemens" type="button">
                        <span className="matrix-vendor">
                          <span className="vmark vm-siemens">
                            <span className="vword siemens">
                              {"SIEMENS"}
                            </span>
                          </span>
                          <span className="matrix-sub">
                            {"TIA Portal / SCL"}
                          </span>
                        </span>
                        <span className="matrix-entry">
                          <span className="matrix-cell ok">
                            <span aria-hidden="true">
                              {"✓"}
                            </span>
                            {" "}
                            <span>
                              {"可生成"}
                            </span>
                          </span>
                        </span>
                        <span className="matrix-entry">
                          <span className="matrix-cell ok">
                            <span aria-hidden="true">
                              {"✓"}
                            </span>
                            {" "}
                            <span>
                              {"经 Agent"}
                            </span>
                          </span>
                        </span>
                        <span className="matrix-entry">
                          <span className="matrix-cell ok">
                            <span aria-hidden="true">
                              {"✓"}
                            </span>
                            {" "}
                            <span>
                              {"已对接"}
                            </span>
                          </span>
                        </span>
                        <span className="matrix-kind live">
                          {"已对接"}
                        </span>
                        <span aria-hidden="true" className="matrix-chevron">
                          {"↗"}
                        </span>
                      </button>
                      <button aria-pressed="false" className="matrix-row" data-kind="core" data-vendor="codesys" type="button">
                        <span className="matrix-vendor">
                          <span className="vmark vm-codesys">
                            <svg aria-hidden="true" viewBox="0 0 26 25">
                              <path d="M2 6.6 13 1l11 5.6-11 5.7z" fill="#a9b3c2">
                              </path>
                              <path d="M2 6.6 13 12.3v11.1L2 17.3z" fill="#e2ebf7">
                              </path>
                              <path d="M13 12.3 24 6.6v10.7l-11 6.1z" fill="#c90015">
                              </path>
                            </svg>
                            <span className="vword codesys">
                              {"CODESYS"}
                            </span>
                          </span>
                          <span className="matrix-sub">
                            {"Development System / ST"}
                          </span>
                        </span>
                        <span className="matrix-entry">
                          <span className="matrix-cell ok">
                            <span aria-hidden="true">
                              {"✓"}
                            </span>
                            {" "}
                            <span>
                              {"可生成"}
                            </span>
                          </span>
                        </span>
                        <span className="matrix-entry">
                          <span className="matrix-cell ok">
                            <span aria-hidden="true">
                              {"✓"}
                            </span>
                            {" "}
                            <span>
                              {"经 Agent"}
                            </span>
                          </span>
                        </span>
                        <span className="matrix-entry">
                          <span className="matrix-cell ok">
                            <span aria-hidden="true">
                              {"✓"}
                            </span>
                            {" "}
                            <span>
                              {"已对接"}
                            </span>
                          </span>
                        </span>
                        <span className="matrix-kind live">
                          {"已对接"}
                        </span>
                        <span aria-hidden="true" className="matrix-chevron">
                          {"↗"}
                        </span>
                      </button>
                      <button aria-pressed="false" className="matrix-row" data-kind="future" data-vendor="omron" type="button">
                        <span className="matrix-vendor">
                          <span className="vmark vm-omron">
                            <span className="vword omron">
                              {"OMRON"}
                            </span>
                          </span>
                          <span className="matrix-sub">
                            {"Sysmac Studio"}
                          </span>
                        </span>
                        <span className="matrix-entry">
                          <span className="matrix-cell pending">
                            <span aria-hidden="true">
                              {"—"}
                            </span>
                            {" "}
                            <span>
                              {"待评估"}
                            </span>
                          </span>
                        </span>
                        <span className="matrix-entry">
                          <span className="matrix-cell pending">
                            <span aria-hidden="true">
                              {"—"}
                            </span>
                            {" "}
                            <span>
                              {"未开放"}
                            </span>
                          </span>
                        </span>
                        <span className="matrix-entry">
                          <span className="matrix-cell pending">
                            <span aria-hidden="true">
                              {"—"}
                            </span>
                            {" "}
                            <span>
                              {"待评估"}
                            </span>
                          </span>
                        </span>
                        <span className="matrix-kind planned">
                          {"适配方向"}
                        </span>
                        <span aria-hidden="true" className="matrix-chevron">
                          {"↗"}
                        </span>
                      </button>
                      <button aria-pressed="false" className="matrix-row" data-kind="future" data-vendor="inovance" type="button">
                        <span className="matrix-vendor">
                          <span className="vmark vm-inovance">
                            <span className="vword inovance">
                              {"INOVANCE"}
                            </span>
                            <small>
                              {"汇川技术"}
                            </small>
                          </span>
                          <span className="matrix-sub">
                            {"AutoShop / IEC 项目"}
                          </span>
                        </span>
                        <span className="matrix-entry">
                          <span className="matrix-cell pending">
                            <span aria-hidden="true">
                              {"—"}
                            </span>
                            {" "}
                            <span>
                              {"待评估"}
                            </span>
                          </span>
                        </span>
                        <span className="matrix-entry">
                          <span className="matrix-cell pending">
                            <span aria-hidden="true">
                              {"—"}
                            </span>
                            {" "}
                            <span>
                              {"未开放"}
                            </span>
                          </span>
                        </span>
                        <span className="matrix-entry">
                          <span className="matrix-cell pending">
                            <span aria-hidden="true">
                              {"—"}
                            </span>
                            {" "}
                            <span>
                              {"待评估"}
                            </span>
                          </span>
                        </span>
                        <span className="matrix-kind planned">
                          {"适配方向"}
                        </span>
                        <span aria-hidden="true" className="matrix-chevron">
                          {"↗"}
                        </span>
                      </button>
                      <button aria-pressed="false" className="matrix-row" data-kind="future" data-vendor="mitsubishi" type="button">
                        <span className="matrix-vendor">
                          <span className="vmark vm-mitsubishi">
                            <svg aria-hidden="true" viewBox="0 0 39 30">
                              <path d="M19.5 1 10.7 15.7h17.6zM9.1 17.3.4 29h17.5zM29.9 17.3 21 29h17.6z" fill="#ef273e">
                              </path>
                            </svg>
                            <span className="vword mitsubishi">
                              {"MITSUBISHI "}
                              <small>
                                {"ELECTRIC"}
                              </small>
                            </span>
                          </span>
                          <span className="matrix-sub">
                            {"GX Works3"}
                          </span>
                        </span>
                        <span className="matrix-entry">
                          <span className="matrix-cell pending">
                            <span aria-hidden="true">
                              {"—"}
                            </span>
                            {" "}
                            <span>
                              {"待评估"}
                            </span>
                          </span>
                        </span>
                        <span className="matrix-entry">
                          <span className="matrix-cell pending">
                            <span aria-hidden="true">
                              {"—"}
                            </span>
                            {" "}
                            <span>
                              {"未开放"}
                            </span>
                          </span>
                        </span>
                        <span className="matrix-entry">
                          <span className="matrix-cell pending">
                            <span aria-hidden="true">
                              {"—"}
                            </span>
                            {" "}
                            <span>
                              {"待评估"}
                            </span>
                          </span>
                        </span>
                        <span className="matrix-kind planned">
                          {"生态调研"}
                        </span>
                        <span aria-hidden="true" className="matrix-chevron">
                          {"↗"}
                        </span>
                      </button>
                      <button aria-pressed="false" className="matrix-row" data-kind="future" data-vendor="schneider" type="button">
                        <span className="matrix-vendor">
                          <span className="vmark vm-schneider">
                            <span className="vword schneider">
                              {"Schneider"}
                              <small>
                                {"Electric"}
                              </small>
                            </span>
                          </span>
                          <span className="matrix-sub">
                            {"Machine Expert"}
                          </span>
                        </span>
                        <span className="matrix-entry">
                          <span className="matrix-cell pending">
                            <span aria-hidden="true">
                              {"—"}
                            </span>
                            {" "}
                            <span>
                              {"待评估"}
                            </span>
                          </span>
                        </span>
                        <span className="matrix-entry">
                          <span className="matrix-cell pending">
                            <span aria-hidden="true">
                              {"—"}
                            </span>
                            {" "}
                            <span>
                              {"未开放"}
                            </span>
                          </span>
                        </span>
                        <span className="matrix-entry">
                          <span className="matrix-cell pending">
                            <span aria-hidden="true">
                              {"—"}
                            </span>
                            {" "}
                            <span>
                              {"待评估"}
                            </span>
                          </span>
                        </span>
                        <span className="matrix-kind planned">
                          {"生态调研"}
                        </span>
                        <span aria-hidden="true" className="matrix-chevron">
                          {"↗"}
                        </span>
                      </button>
                      <button aria-pressed="false" className="matrix-row" data-kind="future" data-vendor="beckhoff" type="button">
                        <span className="matrix-vendor">
                          <span className="vmark vm-beckhoff">
                            <span className="vword beckhoff">
                              {"BECKHOFF"}
                            </span>
                          </span>
                          <span className="matrix-sub">
                            {"TwinCAT 3"}
                          </span>
                        </span>
                        <span className="matrix-entry">
                          <span className="matrix-cell pending">
                            <span aria-hidden="true">
                              {"—"}
                            </span>
                            {" "}
                            <span>
                              {"待评估"}
                            </span>
                          </span>
                        </span>
                        <span className="matrix-entry">
                          <span className="matrix-cell pending">
                            <span aria-hidden="true">
                              {"—"}
                            </span>
                            {" "}
                            <span>
                              {"未开放"}
                            </span>
                          </span>
                        </span>
                        <span className="matrix-entry">
                          <span className="matrix-cell pending">
                            <span aria-hidden="true">
                              {"—"}
                            </span>
                            {" "}
                            <span>
                              {"待评估"}
                            </span>
                          </span>
                        </span>
                        <span className="matrix-kind planned">
                          {"生态调研"}
                        </span>
                        <span aria-hidden="true" className="matrix-chevron">
                          {"↗"}
                        </span>
                      </button>
                      <button aria-pressed="false" className="matrix-row" data-kind="future" data-vendor="rockwell" type="button">
                        <span className="matrix-vendor">
                          <span className="vmark vm-rockwell">
                            <span className="vword rockwell">
                              {"Rockwell"}
                              <small>
                                {"Automation"}
                              </small>
                            </span>
                          </span>
                          <span className="matrix-sub">
                            {"Studio 5000"}
                          </span>
                        </span>
                        <span className="matrix-entry">
                          <span className="matrix-cell pending">
                            <span aria-hidden="true">
                              {"—"}
                            </span>
                            {" "}
                            <span>
                              {"待评估"}
                            </span>
                          </span>
                        </span>
                        <span className="matrix-entry">
                          <span className="matrix-cell pending">
                            <span aria-hidden="true">
                              {"—"}
                            </span>
                            {" "}
                            <span>
                              {"未开放"}
                            </span>
                          </span>
                        </span>
                        <span className="matrix-entry">
                          <span className="matrix-cell pending">
                            <span aria-hidden="true">
                              {"—"}
                            </span>
                            {" "}
                            <span>
                              {"待评估"}
                            </span>
                          </span>
                        </span>
                        <span className="matrix-kind planned">
                          {"生态调研"}
                        </span>
                        <span aria-hidden="true" className="matrix-chevron">
                          {"↗"}
                        </span>
                      </button>
                    </div>
                  </div>
                  <div className="eco-key">
                    <span>
                      <i className="legend-ready">
                      </i>
                      {" 已完成重点对接 / 按环境配置"}
                    </span>
                    <span>
                      <i className="legend-planned">
                      </i>
                      {" 适配方向，尚未承诺正式支持"}
                    </span>
                  </div>
                </div>
                <aside aria-label="选定厂商的适配说明" className="eco-detail">
                  <div className="detail-top">
                    <span>
                      {"ECOSYSTEM / SELECTED"}
                    </span>
                    <span className="detail-mark">
                      {"01 / 08"}
                    </span>
                  </div>
                  <div className="detail-logo" id="ecoDetailLogo">
                    <span className="vmark vm-siemens">
                      <span className="vword siemens">
                        {"SIEMENS"}
                      </span>
                    </span>
                  </div>
                  <h3 id="ecoDetailName">
                    {"TIA Portal + Siemens SCL"}
                  </h3>
                  <p id="ecoDetailText">
                    {"SCL / SimaticML 结合 TIA 工程环境原生检查与诊断回传。"}
                  </p>
                  <div className="detail-progress">
                    <span>
                      {"代码生成"}
                    </span>
                    <span className="detail-chip ready" id="ecoDetailChip">
                      {"原生验证链路"}
                    </span>
                  </div>
                  <div className="detail-steps" id="ecoDetailSteps">
                    <span>
                      <b>
                        {"01"}
                      </b>
                      {" 需求 / 工程约束"}
                    </span>
                    <span>
                      <b>
                        {"02"}
                      </b>
                      {" ST / SCL 工件"}
                    </span>
                    <span>
                      <b>
                        {"03"}
                      </b>
                      {" 原生 IDE 编译诊断"}
                    </span>
                  </div>
                  <div className="detail-actions">
                    <button className="detail-demo" id="ecoDetailDemo" type="button">
                      {"查看工程任务演示 "}
                      <span>
                        {"↗"}
                      </span>
                    </button>
                    <a href="https://www.siemens.com/" id="ecoDetailOfficial" rel="noopener noreferrer" target="_blank">
                      {"厂商官方信息 ↗"}
                    </a>
                  </div>
                  <p className="detail-legal">
                    {"第三方品牌仅用于说明目标工业生态，不表示合作、认可或认证。"}
                  </p>
                </aside>
              </div>
            </div>
            <div className="eco-footnote">
              <span>
                {"⚑"}
              </span>
              <span>
                {"具体兼容性以 Agent 与 IDE 环境为准。扩展平台仍在评估中。"}
              </span>
            </div>
          </div>
        </section>
        <section className="model-choice-section" id="modelChoice" aria-labelledby="modelChoiceTitle">
          <div className="container model-choice-layout">
            <div className="model-choice-copy">
              <div className="model-choice-eyebrow">
                <span className="model-choice-dot" aria-hidden="true">
                </span>
                {" OPEN MODEL ARCHITECTURE · DATA GOVERNANCE"}
              </div>
              <h2 id="modelChoiceTitle">
                {"模型自由选择，"}
                <br />
                <em>
                  {"工程数据边界可控。"}
                </em>
              </h2>
              <p>
                {"RealPLC 不绑定单一大语言模型。可选用 "}
                <strong>
                  {"RealPLC AutoFree"}
                </strong>
                {" 模型路由、第三方模型服务，或企业自建的私有化模型端点。模型接入与工程验证独立配置，可按任务质量、成本与部署要求选择。"}
              </p>
              <div className="model-choice-provider-row" aria-label="支持接入的模型生态">
                <span>
                  {"RealPLC AutoFree"}
                </span>
                <span>
                  {"DeepSeek"}
                </span>
                <span>
                  {"GLM"}
                </span>
                <span>
                  {"Qwen"}
                </span>
                <span>
                  {"Kimi"}
                </span>
                <span>
                  {"私有模型"}
                </span>
              </div>
              <div className="model-choice-security">
                <span aria-hidden="true">
                  {"◇"}
                </span>
                <div>
                  <strong>
                    {"企业可控的数据治理路径"}
                  </strong>
                  <small>
                    {"私有模型配合内网网关与访问策略，可按部署要求在本地或企业网络内完成推理。第三方 API 的数据传输与处理范围以具体供应商、网关配置及服务条款为准。"}
                  </small>
                </div>
              </div>
            </div>
            <div className="model-choice-console" aria-label="模型接入方式示意，非实时服务状态">
              <div className="model-choice-console-head">
                <span>
                  <i>
                  </i>
                  {" MODEL ROUTING"}
                </span>
                <span>
                  {"配置示意 · 非实时连接"}
                </span>
              </div>
              <div className="model-choice-options" role="group" aria-label="查看模型接入方案">
                <button type="button" className="is-selected" data-model-mode="autofree" aria-pressed="true">
                  <span className="model-mode-icon">
                    {"01"}
                  </span>
                  <span>
                    <strong>
                      {"RealPLC AutoFree"}
                    </strong>
                    <small>
                      {"平台模型路由"}
                    </small>
                  </span>
                  <span aria-hidden="true">
                    {"↗"}
                  </span>
                </button>
                <button type="button" data-model-mode="api" aria-pressed="false">
                  <span className="model-mode-icon">
                    {"02"}
                  </span>
                  <span>
                    <strong>
                      {"第三方模型 API"}
                    </strong>
                    <small>
                      {"DeepSeek · GLM · Qwen · Kimi"}
                    </small>
                  </span>
                  <span aria-hidden="true">
                    {"↗"}
                  </span>
                </button>
                <button type="button" data-model-mode="private" aria-pressed="false">
                  <span className="model-mode-icon">
                    {"03"}
                  </span>
                  <span>
                    <strong>
                      {"私有化模型端点"}
                    </strong>
                    <small>
                      {"本地部署 / 企业内网"}
                    </small>
                  </span>
                  <span aria-hidden="true">
                    {"↗"}
                  </span>
                </button>
              </div>
              <div className="model-choice-details" aria-live="polite">
                <span id="modelModeLabel">
                  {"当前方案 · RealPLC AutoFree"}
                </span>
                <strong id="modelModeHeadline">
                  {"按可用模型与平台路由策略选择"}
                </strong>
                <p id="modelModeExplanation">
                  {"用于快速体验和常规工程任务；具体模型可用性、配额和响应质量以平台实际配置为准。"}
                </p>
                <div className="model-data-path">
                  <span>
                    {"工程工作区"}
                  </span>
                  <b aria-hidden="true">
                    {"→"}
                  </b>
                  <span id="modelModeGateway">
                    {"RealPLC 模型路由"}
                  </span>
                  <b aria-hidden="true">
                    {"→"}
                  </b>
                  <span id="modelModeTarget">
                    {"已配置模型服务"}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="section" id="strength">
          <div className="container">
            <div className="section-head">
              <div>
                <div className="eyebrow">
                  {"WHY REALPLC"}
                </div>
                <h2>
                  {"工程的价值，不止于代码生成。"}
                </h2>
              </div>
              <p>
                {"真正重要的是保留工程上下文与可复核的验证证据。"}
              </p>
            </div>
            <div className="double">
              <div className="value-card">
                <div className="value-text">
                  <div className="eyebrow">
                    {"ENGINEERING CONTEXT"}
                  </div>
                  <h3>
                    {"项目能继续，而不是每次重新解释。"}
                  </h3>
                  <p>
                    {"需求确认、项目背景、审批决定与生成工件保持关联。下一轮修改围绕已有工程继续推进。"}
                  </p>
                </div>
                <div className="v-ui">
                  <div className="ln">
                    <span>
                      {"✓"}
                    </span>
                    <strong>
                      {"项目 / 包装输送线改造"}
                    </strong>
                    <em>
                      {"PROJECT CONTEXT"}
                    </em>
                  </div>
                  <div className="ln">
                    <span>
                      {"●"}
                    </span>
                    <strong>
                      {"决策 / 故障清除后仅允许人工复位"}
                    </strong>
                    <em>
                      {"已确认"}
                    </em>
                  </div>
                  <div className="ln">
                    <span>
                      {"●"}
                    </span>
                    <strong>
                      {"工件 / FB_ConveyorControl.st"}
                    </strong>
                    <em>
                      {"v2"}
                    </em>
                  </div>
                  <div className="ln">
                    <span>
                      {"↻"}
                    </span>
                    <strong>
                      {"后续 / 增加运行反馈超时保护"}
                    </strong>
                    <em>
                      {"待验证"}
                    </em>
                  </div>
                </div>
              </div>
              <div className="value-card">
                <div className="value-text">
                  <div className="eyebrow">
                    {"VALIDATION EVIDENCE"}
                  </div>
                  <h3>
                    {"用原生编译结果，支持每一次修复。"}
                  </h3>
                  <p>
                    {"编译结果、诊断信息与代码版本保持关联，为后续修复和复验提供依据。"}
                  </p>
                </div>
                <div className="v-ui">
                  <div className="ln">
                    <span>
                      {"01"}
                    </span>
                    <strong>
                      {"Generate"}
                    </strong>
                    <em>
                      {"ST / SCL"}
                    </em>
                  </div>
                  <div className="ln">
                    <span>
                      {"02"}
                    </span>
                    <strong>
                      {"RealPLC Agent → IDE"}
                    </strong>
                    <em>
                      {"LOCAL"}
                    </em>
                  </div>
                  <div className="ln">
                    <span>
                      {"03"}
                    </span>
                    <strong>
                      {"Compile → Diagnostics"}
                    </strong>
                    <em>
                      {"RESULT"}
                    </em>
                  </div>
                  <div className="ln">
                    <span>
                      {"04"}
                    </span>
                    <strong>
                      {"Fix → Validate again"}
                    </strong>
                    <em>
                      {"ITERATE"}
                    </em>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="section future" id="possibilities">
          <div className="container">
            <div className="section-head">
              <div>
                <div className="eyebrow">
                  {"EXTENSIBLE ENGINEERING"}
                </div>
                <h2>
                  {"扩展能力，按需启用。"}
                </h2>
              </div>
              <p>
                {"PLC 工程为核心，HMI 和仿真按照实际能力与项目配置使用。"}
              </p>
            </div>
            <div className="future-cards">
              <div className="future-card">
                <span className="f-ico">
                  {"▦"}
                </span>
                <h3>
                  {"PLC 代码与原生验证"}
                </h3>
                <p>
                  {"基于 ST/SCL 工程生成，通过本地 Agent 与现有 PLC 开发工具建立验证链路。"}
                </p>
                <span className="status">
                  {"核心能力"}
                </span>
              </div>
              <div className="future-card">
                <span className="f-ico">
                  {"▣"}
                </span>
                <h3>
                  {"HMI 人机界面"}
                </h3>
                <p>
                  {"当需求明确包含 HMI 时，可按配置选择 HTML HMI 或 IDE 原生可视化路线。"}
                </p>
                <span className="status">
                  {"按需启用 / 兼容性依工程而定"}
                </span>
              </div>
              <div className="future-card">
                <span className="f-ico">
                  {"⬡"}
                </span>
                <h3>
                  {"3D 虚拟调试"}
                </h3>
                <p>
                  {"探索 3D 场景与 PLC 程序联动验证，逐步完善设备与接口适配。"}
                </p>
                <span className="status concept">
                  {"探索中"}
                </span>
              </div>
            </div>
          </div>
        </section>
        <section className="section resources-section" id="resources" aria-labelledby="resourcesTitle">
          <div className="container">
            <div className="section-head">
              <div>
                <div className="eyebrow">
                  {"RESOURCES & SUPPORT"}
                </div>
                <h2 id="resourcesTitle">
                  {"开始使用，需要的都在这里。"}
                </h2>
              </div>
              <p>
                {"下载本地组件、了解接入方式，遇到问题也有清晰的下一步。"}
              </p>
            </div>
            <div className="resource-grid">
              <a className="resource-card" href={AGENT_DOWNLOAD_URL} target="_blank" rel="noopener noreferrer" aria-label="立即下载 RealPLC Agent Windows 安装包">
                <span className="resource-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <path d="M12 3v12m-5-5 5 5 5-5M4 16v5h16v-5">
                    </path>
                  </svg>
                </span>
                <span className="resource-type">
                  {"DOWNLOAD"}
                </span>
                <h3>
                  {"获取 RealPLC Agent"}
                </h3>
                <p>
                  {"下载 Windows 本地组件，连接 TIA Portal 与 CODESYS。"}
                </p>
                <span className="resource-link">
                  {"立即下载 "}
                  <span aria-hidden="true">
                    {"↗"}
                  </span>
                </span>
              </a>
              <a className="resource-card" href="https://github.com/JadeHuang/RealPLC-Agent#readme" target="_blank" rel="noopener noreferrer">
                <span className="resource-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <path d="M12 6c-3-3-7-3-10-2v15c4-1 7-1 10 2m0-15c3-3 7-3 10-2v15c-4-1-7-1-10 2V6">
                    </path>
                  </svg>
                </span>
                <span className="resource-type">
                  {"DOCUMENTATION"}
                </span>
                <h3>
                  {"接入与使用说明"}
                </h3>
                <p>
                  {"了解 TIA Portal、CODESYS 与本地 Agent 的接入方式。"}
                </p>
                <span className="resource-link">
                  {"阅读项目文档 "}
                  <span aria-hidden="true">
                    {"↗"}
                  </span>
                </span>
              </a>
              <a className="resource-card" href="#faq" data-nav="faq">
                <span className="resource-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <circle cx="12" cy="12" r="9">
                    </circle>
                    <path d="M9.1 9a3 3 0 0 1 5.8 1c0 2-3 2-3 4m.1 3h.01">
                    </path>
                  </svg>
                </span>
                <span className="resource-type">
                  {"GET HELP"}
                </span>
                <h3>
                  {"常见问题与支持"}
                </h3>
                <p>
                  {"了解编译验证、工程使用边界与可选能力。"}
                </p>
                <span className="resource-link">
                  {"查看常见问题 "}
                  <span aria-hidden="true">
                    {"→"}
                  </span>
                </span>
              </a>
            </div>
            <div className="resources-contact">
              <span>
                {"有具体项目，或需要交流接入方案？"}
              </span>
              <a href="#contact" data-route="contact">
                {"联系我们 "}
                <span aria-hidden="true">
                  {"↗"}
                </span>
              </a>
            </div>
          </div>
        </section>
        <section className="section faq-section" id="faq" aria-labelledby="faqTitle">
          <div className="container faq-layout">
            <div className="faq-intro">
              <div className="eyebrow">
                {"FREQUENTLY ASKED"}
              </div>
              <h2 id="faqTitle">
                {"工程师最关心的"}
                <br className="faq-desktop-break" />
                {"问题。"}
              </h2>
              <p>
                {"了解原生编译、工程验证与可选扩展能力。"}
              </p>
              <div className="faq-intro-note">
                <span aria-hidden="true">
                  {"↗"}
                </span>
                <div>
                  <strong>
                    {"真实编译结果来自真实工具"}
                  </strong>
                  <small>
                    {"AI 生成、原生编译与现场调试是不同的验证层级。"}
                  </small>
                </div>
              </div>
            </div>
            <div className="faq" aria-label="常见问题与解答">
              <details open={true}>
                <summary>
                  {"RealPLC 会代替 TIA Portal 或 CODESYS 吗？"}
                </summary>
                <p>
                  {"不会。RealPLC 主要承担需求理解、计划、代码生成、审批、诊断和迭代；原生工程操作及编译验证由你已有的工业软件及其相应的本地 Agent 能力执行。"}
                </p>
              </details>
              <details>
                <summary>
                  {"如何区分交互演示与真实编译结果？"}
                </summary>
                <p>
                  {"首页动画和工程演示使用示例数据。项目中的真实编译结果由本地 Agent 调用目标 IDE 后返回，需要安装对应软件并配置工程环境。"}
                </p>
              </details>
              <details>
                <summary>
                  {"生成代码后，还需要哪些工程验证？"}
                </summary>
                <p>
                  {"代码生成后仍需工程师审查、原生编译、功能测试与现场调试。编译通过只代表编译检查通过，投用前还需完成项目要求的安全与验收流程。"}
                </p>
              </details>
              <details>
                <summary>
                  {"HMI 与 3D 仿真是不是默认生成？"}
                </summary>
                <p>
                  {"不是。HMI 应在明确需求和启用相关功能后纳入工程方案；3D 仿真作为可选拓展方向展示，具体落地和兼容性需要独立验证。"}
                </p>
              </details>
            </div>
          </div>
        </section>
        <div className="cta-section" aria-label="开始使用 RealPLC">
          <div className="cta-message">
            <div className="eyebrow">
              {"MAKE IT REAL"}
            </div>
            <h2>
              {"一个控制需求，"}
              <br />
              {"开启一个可追溯的工程项目。"}
            </h2>
            <p>
              {"先体验工程流程，再进入 RealPLC 工作区。"}
            </p>
          </div>
          <div className="cta-actions">
            <button className="btn primary" data-route="demo" type="button">
              {"体验完整流程 →"}
            </button>
            <button className="btn ghost" data-route="login" type="button">
              {"登录并创建项目 →"}
            </button>
          </div>
        </div>
      </div>
      <div className="view" id="view-demo">
        <div className="demo-shell">
          <div className="container">
            <button className="page-back" data-route="home" type="button">
              {"← 返回产品首页"}
            </button>
            <div className="demo-head">
              <div>
                <div className="eyebrow">
                  {"LIVE INTERACTION / MOCK ENGINE"}
                </div>
                <h1>
                  {"看看一次 PLC 工程任务如何推进。"}
                </h1>
                <p>
                  {"可切换设备场景、开发环境和工作流阶段，并体验审批及故障修复交互。"}
                </p>
              </div>
              <span className="sim-tag">
                {"⚠ 产品交互演示 · 非真实 AI 或 IDE 编译"}
              </span>
            </div>
            <div className="scenario-picker" id="demoScenarios">
              <button className="active" data-scene="conveyor" type="button">
                {"输送线启停"}
              </button>
              <button data-scene="motor" type="button">
                {"电机联锁"}
              </button>
              <button data-scene="mixer" type="button">
                {"批次混料"}
              </button>
              <button data-scene="alarm" type="button">
                {"报警矩阵"}
              </button>
            </div>
            <div className="demo-layout">
              <aside className="demo-panel">
                <div className="panel-h">
                  {"工程阶段 "}
                  <span className="muted">
                    {"01 — 05"}
                  </span>
                </div>
                <div className="step-list" id="stepList">
                </div>
              </aside>
              <section className="demo-panel demo-core">
                <div className="core-context">
                  <div className="tiny">
                    {"PROJECT / "}
                    <span id="demoProjectCode">
                      {"DEMO-LINE-001"}
                    </span>
                  </div>
                  <h2 id="demoSceneTitle">
                    {"输送线启停控制"}
                  </h2>
                  <p id="demoSceneShort">
                    {"控制要求和验收约束纳入同一个工程任务"}
                  </p>
                </div>
                <div aria-live="polite" className="demo-viewpad" id="demoContent">
                </div>
              </section>
              <aside className="demo-panel right-panel">
                <div className="panel-h">
                  {"工程上下文 "}
                  <span className="run-status" id="demoRunState">
                    {"示例会话"}
                  </span>
                </div>
                <div className="right-inner">
                  <div className="meta-row">
                    <span>
                      {"开发环境"}
                    </span>
                    <b id="metaPlatform">
                      {"CODESYS ST"}
                    </b>
                  </div>
                  <div className="meta-row">
                    <span>
                      {"项目阶段"}
                    </span>
                    <b id="metaStep">
                      {"需求确认"}
                    </b>
                  </div>
                  <div className="meta-row">
                    <span>
                      {"版本工件"}
                    </span>
                    <b id="metaArtifact">
                      {"v1 / Draft"}
                    </b>
                  </div>
                  <div className="meta-row">
                    <span>
                      {"当前审批"}
                    </span>
                    <b id="metaReview">
                      {"待确认"}
                    </b>
                  </div>
                  <h4>
                    {"关键工程信号 / 示例"}
                  </h4>
                  <table className="signal-table">
                    <thead>
                      <tr>
                        <th>
                          {"变量"}
                        </th>
                        <th>
                          {"类型"}
                        </th>
                        <th>
                          {"校验"}
                        </th>
                      </tr>
                    </thead>
                    <tbody id="signalBody">
                    </tbody>
                  </table>
                  <div className="disclaimer">
                    {"本演示所有流程为本地浏览器内的状态模拟，不会连接云端、PLC 或编程软件，也不会创建真实工程。"}
                  </div>
                </div>
              </aside>
            </div>
          </div>
        </div>
      </div>
      <div className="view" id="view-contact">
        <section className="contact-page" aria-labelledby="contactTitle">
          <div className="container">
            <div className="contact-breadcrumb">
              <a href="#home" data-route="home">
                {"首页"}
              </a>
              <span aria-hidden="true">
                {"/"}
              </span>
              <span>
                {"联系我们"}
              </span>
            </div>
            <div className="contact-heading">
              <div>
                <div className="eyebrow">
                  <span className="pulse" aria-hidden="true">
                  </span>
                  {" CONTACT REALPLC"}
                </div>
                <h1 id="contactTitle">
                  {"把你的工程需求，"}
                  <br />
                  <span>
                    {"和我们聊一聊。"}
                  </span>
                </h1>
                <p>
                  {"产品咨询、Agent 接入与项目合作，都可以从这里开始。"}
                </p>
              </div>
              <div className="contact-intro-note">
                <span>
                  {"FROM CONTROL IDEAS"}
                  <br />
                  {"TO REAL ENGINEERING."}
                </span>
                <p>
                  {"先聊清楚设备、平台与工程目标，"}
                  <br />
                  {"再一起确定合适的接入方式。"}
                </p>
              </div>
            </div>
            <div className="contact-grid">
              <div className="contact-details-panel">
                <div className="contact-panel-heading">
                  <span>
                    {"联系信息"}
                  </span>
                  <span className="contact-panel-label">
                    {"DIRECT CONTACT"}
                  </span>
                </div>
                <div className="contact-detail">
                  <span className="contact-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                      <path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1 1 .4 2 .7 2.9a2 2 0 0 1-.5 2.1L8 10a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.5c.9.3 1.9.6 2.9.7a2 2 0 0 1 1.7 2z">
                      </path>
                    </svg>
                  </span>
                  <div>
                    <span className="contact-label">
                      {"联系电话"}
                    </span>
                    <a className="contact-phone" href={"tel:" + legalFooter.phone}>
                      {legalFooter.phone}
                    </a>
                    <p>
                      {"产品咨询 · 项目合作 · 接入沟通"}
                    </p>
                  </div>
                </div>
                <div className="contact-detail">
                  <span className="contact-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                      <path d="M20 10c0 6-8 12-8 12S4 16 4 10a8 8 0 1 1 16 0z">
                      </path>
                      <circle cx="12" cy="10" r="2.5">
                      </circle>
                    </svg>
                  </span>
                  <div>
                    <span className="contact-label">
                      {"公司地址"}
                    </span>
                    <address id="companyAddress">
                      {legalFooter.address}
                    </address>
                    <button type="button" className="contact-copy" id="copyCompanyAddress">
                      {"复制地址 "}
                      <span aria-hidden="true">
                        {"↗"}
                      </span>
                    </button>
                    <span className="copy-status" id="contactCopyStatus" role="status" aria-live="polite">
                    </span>
                  </div>
                </div>
                <div className="contact-detail">
                  <span className="contact-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                      <rect x="4" y="3" width="16" height="18" rx="2">
                      </rect>
                      <path d="M9 21v-4h6v4M8 7h1m6 0h1M8 11h1m6 0h1">
                      </path>
                    </svg>
                  </span>
                  <div>
                    <span className="contact-label">
                      {"公司主体"}
                    </span>
                    <strong className="contact-company">
                      {legalFooter.company}
                    </strong>
                  </div>
                </div>
              </div>
              <aside className="contact-preparation">
                <div className="eyebrow">
                  {"LET'S START WITH THE DETAILS"}
                </div>
                <h2>
                  {"带上这些信息，"}
                  <br />
                  {"沟通会更高效。"}
                </h2>
                <ol>
                  <li>
                    <span>
                      {"01"}
                    </span>
                    <div>
                      <strong>
                        {"开发环境"}
                      </strong>
                      <p>
                        {"PLC 品牌、型号，以及 TIA Portal 或 CODESYS 版本。"}
                      </p>
                    </div>
                  </li>
                  <li>
                    <span>
                      {"02"}
                    </span>
                    <div>
                      <strong>
                        {"工程目标"}
                      </strong>
                      <p>
                        {"希望完成的设备控制、代码生成或编译验证任务。"}
                      </p>
                    </div>
                  </li>
                  <li>
                    <span>
                      {"03"}
                    </span>
                    <div>
                      <strong>
                        {"当前问题"}
                      </strong>
                      <p>
                        {"相关报错、Agent 版本与脱敏后的复现信息。"}
                      </p>
                    </div>
                  </li>
                </ol>
                <a className="contact-issue-link" href="https://github.com/JadeHuang/RealPLC-Agent/issues" target="_blank" rel="noopener noreferrer">
                  {"查看 Agent 问题与反馈 "}
                  <span aria-hidden="true">
                    {"↗"}
                  </span>
                </a>
              </aside>
            </div>
            <div className="contact-bottom">
              <span>
                {"想先了解 RealPLC 的工作方式？"}
              </span>
              <button type="button" className="btn ghost" data-route="demo">
                {"体验工程流程 "}
                <span aria-hidden="true">
                  {"→"}
                </span>
              </button>
            </div>
          </div>
        </section>
      </div>
    </main>
    <footer className="foot" aria-label="公司与备案信息">
      <div className="container footin">
        <div className="footer-brand">
          <a className="logo" href="#home" data-route="home" aria-label="RealPLC 首页">
            <span aria-hidden="true" className="official-logo">
            </span>
            <span>
              {"RealPLC"}
            </span>
          </a>
          <p>
            {"AI 驱动的 PLC 工程平台"}
          </p>
        </div>
        <nav className="footer-links" aria-label="页脚导航">
          <div className="footer-link-group">
            <h3>
              {"产品"}
            </h3>
            <a data-route="home" href="#home">
              {"首页"}
            </a>
            <a data-route="demo" href="#demo">
              {"工程演示"}
            </a>
          </div>
          <div className="footer-link-group">
            <h3>
              {"支持与联系"}
            </h3>
            <a href="#resources" data-nav="resources">
              {"资源与支持"}
            </a>
            <a href="https://github.com/JadeHuang/RealPLC-Agent" rel="noopener noreferrer" target="_blank">
              {"Agent 开源仓库 ↗"}
            </a>
            <a href="#contact" data-route="contact">
              {"联系我们"}
            </a>
          </div>
        </nav>
      </div>
      <div className="container site-legal">
        <p>
          {"© "}{legalFooter.company}{" 2026 版权所有"}
        </p>
        <p className="registration-links">
          <a href={legalFooter.gongAnUrl} target="_blank" rel="noopener noreferrer">
            <img src="/gongan.png" alt="公安备案图标" width="16" height="16" />
            {" "}{legalFooter.gongAn}
          </a>
          <span className="legal-divider" aria-hidden="true">
            {"|"}
          </span>
          <a href={legalFooter.icpUrl} target="_blank" rel="noopener noreferrer">
            {legalFooter.icp}
          </a>
        </p>
      </div>
    </footer>
  </>;
}
